angular.module('dybReportsAffnet', ['classy', 'dybCharts', 'dyb.programs', 'dyb.util', 'dybTags']);